<template>
    <div>
        <breadCrumb 
            :icon="'fa-cart-plus'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_outstandings`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'date'" class="row mt-3">
            <div class="col-sm-6 col-xl-3" v-for="box in outstandingsReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'customer'" class="row mt-3">
            <div class="col-sm-6 col-xl-3">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g bg-success-500">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{balance}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{$t('salon_report.header_balance')}}</small>
                        </h3>
                    </div>
                    <i class="fal fa-search-dollar position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportCreditTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <outstandingsFilter ref="outstandingsFilter" :tab="selectedTab" @setCreditBalance="setCreditBalance" @filterCreditSummary="filterCreditSummary" @filterCreditList="filterCreditList"></outstandingsFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-5">
                            <outstandingsSummary ref="outstandingsSummary" class="tab-pane" :class="{'active': selectedTab == 'summary'}" @setSummary="setSummary" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></outstandingsSummary>               
                            <outstandingsList ref="outstandingsList" class="tab-pane" :class="{'active': selectedTab == 'list'}" @setExportData="setExportData"></outstandingsList>               
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import OutstandingsFilter from './Outstandings_Filter'
import OutstandingsList from './Outstandings_List'
import OutstandingsSummary from './Outstandings_Summary'

import box from './../../../../assets/js/dashboard/salonReport/salonReport'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "reportOutstandings",
    components:{
        OutstandingsFilter, OutstandingsList, OutstandingsSummary, BreadCrumb
    },
    data(){
        return {
            selectedTab: "summary",
            outstandingsReportSummaryBox: [],
            filterObj: {}, 
            summaryTab: "customer",
            balance: 0,
        }
    },
    watch:{
        selectedTab(value){
            value == 'list' ? this.$refs.outstandingsList.getCreditList(this.filterObj) : this.$refs.outstandingsSummary.handleCreditSummary(this.filterObj);
            this.$refs.outstandingsFilter.updateSummaryType(value);
        },
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        }
    },
    methods:{
        async filterCreditSummary(filterObj){
            this.filterObj = filterObj;
            await this.$refs.outstandingsSummary.handleCreditSummary(this.filterObj);
        },
        filterCreditList(filterObj){
            this.filterObj = filterObj;
            this.$refs.outstandingsList.getCreditList(this.filterObj);
        },
        setSummary(data){
            for(var i=0; i<this.outstandingsReportSummaryBox.length; i++){
                switch(this.outstandingsReportSummaryBox[i].id){
                    case"outstandings":
                        this.outstandingsReportSummaryBox[i].value = formatPrice(data.summary.topup);
                        break
                    case"collection":
                        this.outstandingsReportSummaryBox[i].value = formatPrice(data.summary.redeem);
                        break
                }
            }
        },
        setCreditBalance(data){
            this.filterObj = data;
            this.$refs.outstandingsSummary.handleCreditSummary(data);
        }, 
        setBalanceSummary(total){
            this.balance = formatPrice(total)
        },
        setExportData(data){
            this.$refs.outstandingsFilter.setExportData(data);
        },
        setSummaryBoxLabel(){
            var _box = box.outStandingsReportSummaryBox
            this.outstandingsReportSummaryBox = setSummaryBoxLabel(this, 'outstandings', _box.slice())
        },
    },
    mounted(){
        let $vm = this
        $vm.setSummaryBoxLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>